/**
 * @ngdoc Controller
 * @name ReportingBaseController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('ReportingBaseController', ReportingBaseController);

    /**
     * @constructor
     * @ngInject
     */
    function ReportingBaseController($log, $scope, ApiService) {
        $log.info('ReportingBaseController');
        $scope.showDynamicESS = false;
        $scope.$watch("installation.id", function() {
            if ($scope.installation) {
                if ($scope.installation.dynamicEssEnabled) {
                    $scope.showDynamicESS = true;
                } else if (!$scope.installation.dynamicEssAvailable) {
                    $scope.showDynamicESS = false;
                } else if ($scope.installation.id) {
                    ApiService.getDynamicEssSettings($scope.installation.id)
                        .then(function(response) {
                            $scope.showDynamicESS = response.success;
                        })
                        .catch(function() {
                            $scope.showDynamicESS = false;
                        });
                }
            } else {
                $scope.showDynamicESS = false;
            }
        });
   }
})();
